import classNames from 'classnames';
import { useCallback, useMemo } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { useIsMobile } from '~/components/Breakpoint/Breakpoint.hook';
import { HomeBanner } from '~/components/Home/Hero/HomeHero.hooks';
import { Chevron } from '~/components/Icon/v2/Chevron';
import styles from './HomeHeroItem.module.scss';

export type HomeHeroItemProps = HomeBanner & {
  className?: string;
};

export const HomeHeroItem = ({
  className,
  title,
  mobileImageUrl,
  mobileLinkUrl,
  pcImageUrl,
  pcLinkUrl,
  buttonName,
}: HomeHeroItemProps) => {
  const isMobile = useIsMobile();
  const url = isMobile ? mobileLinkUrl : pcLinkUrl;
  const isOuterLink = useMemo(() => new URL(url).origin !== window.location.origin, [url]);

  const linkTo = useMemo(() => {
    const urlObj = new URL(url);
    return urlObj.pathname + urlObj.search;
  }, [url]);

  const history = useHistory();
  const onButtonClick = useCallback(
    (e) => {
      e.stopImmediatePropagation();
      if (isOuterLink) {
        window.location.href = url;
      } else {
        history.push(linkTo);
      }
    },
    [history, isOuterLink, linkTo, url]
  );

  return isOuterLink ? (
    <a
      href={url}
      className={classNames(styles.root, className)}
      data-event="click"
      data-event-target="banner_in_home">
      <p className={styles.content}>{title}</p>
      <span className={styles.button} onClick={onButtonClick}>
        {buttonName} <Chevron className={styles.icon} />
      </span>
      <img
        src={isMobile ? mobileImageUrl : pcImageUrl}
        alt={title}
        width={200}
        height={160}
        className={styles.image}
      />
    </a>
  ) : (
    <Link
      to={linkTo}
      className={classNames(styles.root, className)}
      data-event="click"
      data-event-target="banner_in_home">
      <p className={styles.content}>{title}</p>
      <span className={styles.button} onClick={onButtonClick}>
        {buttonName} <Chevron className={styles.icon} />
      </span>
      <img
        src={isMobile ? mobileImageUrl : pcImageUrl}
        alt={title}
        width={200}
        height={160}
        className={styles.image}
      />
    </Link>
  );
};
